import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { GuestModule } from './guest/guest.module';
import { AdminModule } from './admin/admin.module';
import { ProfileService } from './shared/services/profile.service';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { PrimeNGConfig, SharedModule, MessageService } from 'primeng/api';
import { ServiceWorkerModule } from '@angular/service-worker';
import { appInitializerFactory } from '@shared/functions/app-initializer';
import { ToastModule } from 'primeng/toast';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer as printerReducer, printerFeatureKey } from './store/printer/printer.reducer';
import { PrinterEffects } from './store/printer/printer.effects';
import { UtilsService } from '@shared/services/utils.service';
import { subMenuItems } from './auth/payments/submenu';
import { DialogService } from 'primeng/dynamicdialog';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

export function initSubMenuItems(utilsService: UtilsService) {
  return () => {
    if (utilsService.validatePermission('see_cash_register')) {
      subMenuItems.push({
        icon: 'assets/icons/icon_cash_closing.png',
        title: 'REGISTRO DE CAJAS',
        route: '/panel/payments/cash-register',
      });
    }

    if (utilsService.validatePermission('see_invoices')) {
      subMenuItems.push({
        icon: 'assets/icons/icon_list.png',
        title: 'LISTA DE FACTURAS',
        route: '/panel/payments/invoices',
      });
    }

    if (utilsService.validatePermission('create_proform')) {
      subMenuItems.push({
        icon: 'assets/icons/icon_list.png',
        title: 'LISTA DE PROFORMAS',
        route: '/panel/payments/proformas',
      });
    }
  };
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    GuestModule,
    AdminModule,
    SharedModule,
    RouterModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreModule.forFeature(printerFeatureKey, printerReducer),
    EffectsModule.forFeature([PrinterEffects]),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    SweetAlert2Module.forRoot()
  ],
  providers: [
    ProfileService,
    MessageService,
    DialogService, // Importante: registramos el DialogService para que esté disponible en los efectos
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [PrimeNGConfig],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initSubMenuItems,
      deps: [UtilsService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
